import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { demeterChartsApi } from '../../../../Apis/Apis';
import NavigationRoutes from '../../../../Layouts/NavigationRoutes';
import useApiWithoutAutoExecute from '../../../Apis/Hooks/useApiWithoutAutoExecute';
import ConfirmModal from '../../../Components/Modals/ConfirmModal/ConfirmModal';
import useLanguage from '../../../Services/Language/useLanguageHook';
import styles from '../ChartBuilder.module.scss';

interface IChartBuilderListActionsProps {
    demeterChartGuid: string;
    refreshListDemeterCharts: () => void;
}

const ChartBuilderListActions: React.FC<IChartBuilderListActionsProps> = (props: IChartBuilderListActionsProps) => {
    const [translations] = useLanguage();
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const [, refreshDeleteDemeterChart, deleteDemeterChartResponse] = useApiWithoutAutoExecute(() =>
        demeterChartsApi.deleteDemeterChart({ demeterChartGuid: props.demeterChartGuid }),
    );

    useEffect(() => {
        if (!deleteDemeterChartResponse) {
            return;
        }

        props.refreshListDemeterCharts();
    }, [deleteDemeterChartResponse]);

    return (
        <div className={styles.chart_builder_list_actions_container}>
            <Link className={styles.chart_builder_list_action} to={`${NavigationRoutes.ChartBuilder}/${props.demeterChartGuid}/edit`}>
                {translations.actions.edit}
            </Link>
            {' | '}
            <button type="button" className={styles.chart_builder_list_action} onClick={() => setDeleteModalOpen(true)}>
                {translations.actions.delete}
            </button>
            <ConfirmModal
                header={translations.chartBuilder.headers.deleteQuestion}
                showModal={deleteModalOpen}
                message={translations.chartBuilder.text.areYouSureDeleteChart}
                handleConfirm={() => {
                    refreshDeleteDemeterChart();
                    setDeleteModalOpen(false);
                }}
                handleCancel={() => setDeleteModalOpen(false)}
                track={{ eventCategory: 'ChartBuilder', eventAction: 'ModalDeleteChart' }}
            />
        </div>
    );
};

export default ChartBuilderListActions;
